export const config = {
    apiUrl: 'https://prod-wazup-front-prod-wazup-back.azurewebsites.net',
    stripePKey: 'pk_live_51GxckpCX1GZy9IFaiC6B8oDDbDBYlUkZ5GGQiJcB5Rj1azrVmdkwIHgzwxOxVTnUgpbFw94WOmjWzeBQdIJD1L5Z00oxdTsgyj',
    googleMapKey: 'AIzaSyCHz6Uf_6BMtBL3WrUMkqXQ3ebwY9iGGSs',
    paypalKey: 'AXtiTammDFHxQi3mE5KBy4SWIaoxRFneJRT53_9UyLc768q1G8MQzKIYPq0KYGOT58rdHBEEC2C64qyP'
}